/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";
import DataTable from "react-data-table-component";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";
import { gridStyles } from "../styles.js";

const columns = [
  {
    name: <Skeleton width={40} />,
    selector: (row) => row.title,
  },
  {
    name: <Skeleton width={40} />,
    selector: (row) => row.year,
  },
  {
    name: <Skeleton width={40} />,
    selector: (row) => row.title,
  },
  {
    name: <Skeleton width={40} />,
    selector: (row) => row.year,
  },
];

const data = Array.from({ length: 7 }, (_, id) => ({
  id: id + 1,
  title: <Skeleton width={100} />,
  year: <Skeleton width={100} />,
}));

const GridSkeleton = ({ gridStyle }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={`${classes.gridSkeletonMainDiv} ${gridStyle ? gridStyle : ""}`}>
      <DataTable columns={columns} data={data} customStyles={gridStyles} />
      <div className={classes.dividerContainer}>
        <hr className={classes.border} />
      </div>
      <div className={classes.skeletonPaginationWrapper}>
        {Array.from({ length: 3 }).map((_, gridSkIndex) => (
          <div key={gridSkIndex} className={classes.skeletonPagination}>
            <Skeleton width={100} count={1} height={25} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GridSkeleton;
